import styled from '@emotion/styled'
import React from 'react'
import { joinName } from 'uniforms'
import { BoolField, ErrorField, SelectField } from 'uniforms-unstyled'
import Grid, { GridItem } from '../../../styles/Grid'
import DatePicker from '../form-fields/DatePicker'
import DisplayIf from '../form-fields/DisplayIf'
import { FlyerCheck, FlyerDateInWords, FlyerYearNote, NotOnFlyer } from './FlyerPrefillContext'

const StyledTimeInput = styled(SelectField)`
  && select {
    width: 100%;
  }
`

const AllDayCheckbox = styled(BoolField)`
  &&.checkbox-row {
    justify-content: flex-start;
    &:before {
      display: none;
    }
  }
`

type Props = { label?: JSX.Element; name?: string }
const StartDateTimeFields: React.FC<Props> = ({ label, name }) => (
  <>
    {label}
    <Grid>
      <GridItem columns={12} medium={6}>
        <DatePicker name={joinName(name, 'startAtDate')} className="dateAndTimeFields-date" />
        {/* What a flyer filled in on the new-event form (CVL-177); nothing otherwise. */}
        <FlyerDateInWords />
        <FlyerYearNote />
        <FlyerCheck field="when" />
      </GridItem>

      <DisplayIf condition={ctx => !ctx.model.allDay}>
        <GridItem columns={12} medium={6}>
          <Grid>
            <GridItem columns={6}>
              <StyledTimeInput name={joinName(name, 'startAtTime')} className="dateAndTimeFields-time" />
            </GridItem>
            <GridItem columns={6}>
              <StyledTimeInput name={joinName(name, 'endAtTime')} className="dateAndTimeFields-time" />
            </GridItem>
          </Grid>
          <NotOnFlyer field="time" />
          <ErrorField name="startAtTimeBlank" />
        </GridItem>
      </DisplayIf>
    </Grid>
    <AllDayCheckbox name="allDay" className="checkbox-row" />
  </>
)

export default StartDateTimeFields
